export default __webpack_public_path__ + "static/bg-move-cba60562e203ca4abff1c1c58b82b8f9.png";